import { Component, OnInit, Input, TemplateRef, ViewChild, ElementRef, OnDestroy, inject, AfterViewInit, output } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { UtilsService, HelpersService } from "src/app/shared";
import { SettingMappingModelService } from "../setting-mapping-model.service";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AddEditComponent } from "@shared/index";

@Component({
    selector: "wk-setting-mapping-column",
    templateUrl: "./setting-mapping-column.component.html",
    styleUrl: "./setting-mapping-column.component.scss",
    standalone: false,
    host: { class: "wk-sm__column" },
})
export class SettingMappingColumnComponent implements OnInit, OnDestroy, AfterViewInit {
    settingMappingModelService = inject(SettingMappingModelService);
    private readonly translate = inject(TranslateService);
    private modalService = inject(BsModalService);
    private helpersService = inject(HelpersService);

    thisIsIE = false;
    bsModalRef?: BsModalRef;
    stepName = "";
    @ViewChild("scrollContainer", { static: false }) scrollContainer: ElementRef;
    mappingColumnChangeSubscription: Subscription;
    @ViewChild("deleteDialogContent") deleteDialogContent!: TemplateRef<any>;
    @Input() column: any;
    @Input() mappingViewmodel: any;
    @Input() columnType: any;
    @Input() order: any;
    @Input() isJobsBillingDashboard: boolean;
    readonly onFormChanged = output<boolean>();
    readonly onDeleteStep = output<any[]>();

    constructor() {
        this.mappingColumnChangeSubscription = this.helpersService.mappingColumnChangeEvent$.subscribe((mappingColumn) => {
            if (mappingColumn) {
                this.updateScrollbarClass();
            }
        });
    }

    ngOnInit() {
        if ("function" !== typeof DataTransfer.prototype.setDragImage) {
            this.thisIsIE = true;
        }
    }

    ngAfterViewInit() {
        this.updateScrollbarClass();
    }

    ngOnDestroy() {
        if (this.mappingColumnChangeSubscription) {
            this.mappingColumnChangeSubscription.unsubscribe();
        }
    }

    onColumnDelete() {
        this.settingMappingModelService.softDeleteColumn(this.columnType, this.column, this.order);
        this.onFormChanged.emit(true);
        this.onDeleteStep.emit([
            {
                columnType: this.columnType,
                column: this.column,
                order: this.order,
            },
        ]);
    }

    public onConfirm(result) {
        this.bsModalRef.hide();
        this.bsModalRef.content = result;
        this.onFormChanged.emit(true);
    }

    showDeletePopup(columnName) {
        this.stepName = columnName[this.translate.getCurrentLang() ? this.translate.getCurrentLang() : this.translate.getFallbackLang()];
        this.bsModalRef = this.modalService.show(this.deleteDialogContent, {
            class: "custom-modal-rename-dashboard",
        });

        this.bsModalRef.onHidden.subscribe(() => {
            if (this.bsModalRef.content == true) {
                this.onColumnDelete();
            }
        });
    }

    editColumn(): void {
        this.bsModalRef = this.modalService.show(AddEditComponent, {
            initialState: {
                title: "Settings.EditStep",
                data: UtilsService.recursiveDeepCopy(this.column),
                callback: (aColumn) => this.onSave(aColumn),
            },
            class: "custom-modal-rename-dashboard",
        });
    }

    onSave(aColumn) {
        this.onFormChanged.emit(true);
        this.column.Name["en-CA"] = aColumn.Name["en-CA"];
        this.column.Name["fr-CA"] = aColumn.Name["fr-CA"];
        this.bsModalRef.hide();
    }
    showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === "DIV" || element.className === "wk-mapping__column--title-name") && element.offsetWidth < element.scrollWidth) {
            element.setAttribute("data-title", element.innerText);
        }
    }

    onDrop() {
        this.onFormChanged.emit(true);
    }

    onMappingStatusFormChanged(event) {
        this.onFormChanged.emit(event);
    }

    hasVerticalScrollbar(element: HTMLElement): boolean {
        return element?.scrollHeight > element?.clientHeight;
    }

    updateScrollbarClass() {
        const element = this.scrollContainer.nativeElement;
        if (element && this.hasVerticalScrollbar(element)) {
            element.classList.add("scrollbar-active");
        } else {
            element.classList.remove("scrollbar-active");
        }
    }
}
